import { get, post, put, _delete } from './Tools';

const getCatalogo = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}roles/catalogo`);
  return response;
};

const getVistasCatalogo = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}vistas/catalogo`);
  return response;
};

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}roles`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}roles`, payload);
  return response;
};

const update = async (id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}roles/${id}`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}roles/${id}`);
  return response;
};

export { getCatalogo, getVistasCatalogo, getAll, insert, update, drop };
